import {
  type EmployersRenewalsEmployeeEmploymentType as EmployeeEmploymentType,
  type EmployersRenewalsEmployeeEnrollmentStatus as EmployeeEnrollmentStatus,
  type GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEmploymentTypesItem as EmploymentTypeFilter,
  type GetEmployersRenewalsRenewalConfigsIdEmployeesFilterEnrollmentStatusesItem as EnrollmentStatusFilter,
} from 'utils/web_api.schemas'

const enrollmentStatusDisplayValue = (enrollmentType: EnrollmentStatusFilter | EmployeeEnrollmentStatus) => {
  switch (enrollmentType) {
    case 'enrolled':
      return 'Enrolled'
    case 'declined':
      return 'Declined'
    case 'not_invited':
      return 'Not invited'
    case 'not_accepted':
      return 'Not accepted'
    case 'offboarded':
      return 'Offboarded'
    default:
      return enrollmentType
  }
}

const employmentTypeDisplayValue = (employmentType: EmploymentTypeFilter | EmployeeEmploymentType) => {
  switch (employmentType) {
    case 'full_time':
      return 'Full-time'
    case 'part_time':
      return 'Part-time'
    default:
      return employmentType
  }
}

export { employmentTypeDisplayValue, enrollmentStatusDisplayValue }
